// Created by hejikun on 2017/11/2 0002.
let rsquo = [
  {
    path: '/rsquo_hospital_list',
    name: '公益项目',
    component: () => import('@/pages/rsquo/rsquo_hospital_list')
  },
  {
    path: '/rsquo',
    name: '先心病',
    component: () => import('@/pages/rsquo/index')
  },
  {
    path: '/rsquo_download',
    name: '下载申请表',
    component: () => import('@/pages/rsquo/download')
  },
  {
    path: '/rsquo_upload',
    name: '上传申请表',
    component: () => import('@/pages/rsquo/upload')
  },
  {
    path: '/registration_rsquo',
    name: '先心病医生列表',
    component: () => import('@/pages/rsquo/registration_rsquo')
  },
  {
    path: '/rsquo_order_list',
    name: '先心病订单列表',
    component: () => import('@/pages/rsquo/rsquo_order_list')
  },
  {
    path: '/intention_apply',
    name: '意向报名',
    component: () => import('@/pages/rsquo/intention_apply')
  },
  {
    path: '/rsquo_type',
    name: '公益项目',
    component: () => import('@/pages/rsquo/rsquo_type')
  },
  {
    path: '/continue_upload',
    name: '上传申请表',
    component: () => import('@/pages/rsquo/continue_upload')
  }
]

export default rsquo
